/* eslint-disable camelcase */
import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CTextarea,
  CLabel,
  CModal,
  CModalHeader,
  CModalTitle,
  CSwitch,
  CSpinner,
  CInputGroup,
  CModalBody,
  CModalFooter,
  CCardFooter
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import Select from "react-select";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  Alert,
  ModalFooter
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import { isTipoFormulario } from "../../config/formularios";
import {
  isTipoOcultoNaTrilha,
  isTrailQueryActive,
  temPassosSuficientes,
  TRILHA_MIN_OBJETOS,
  TRILHA_REGIAO_PADRAO,
  TRILHA_REGIAO_TRAVADA_AVISO
} from "../../config/minhasTrilhas";
import { isTipoOcultoNaAtividade } from "../../config/objetosAtividade";
import {
  descricaoParaEditor,
  temFormatoDeEditor
} from "../../utils/descricaoAtividade";
import { caminhoDoLo } from "../../utils/loSingleView";
import ApplicatedQuestionList from "../ApplicatedQuestionList/ApplicatedQuestionList";
import Cards from "../Cards/Cards";
import ClickAndDropActivity from "../ClickAndDropActivity/ClickAndDropActivity";
import ContentComponentActivity from "../Content/ContentActivity";
import FileCreator from "../Content/FileCreator";
import LinkCreator from "../Content/LinkCreator";
import TextCreator from "../Content/TextCreator";
import UploadCreator from "../Content/UploadCreator";
import EscolhaDeRegiao from "../CriadorDeTrilha/EscolhaDeRegiao";
import PercursoDaTrilha from "../CriadorDeTrilha/PercursoDaTrilha";
import PreviaDoAluno from "../CriadorDeTrilha/PreviaDoAluno";
import FormularioPicker, {
  FormularioEditor
} from "../Formulario/FormularioPicker";
import Interface from "../Interface";
import LiterarteModal from "../LiterarteModal";
import Loading from "../Loading";
import ModalActivity from "../Modal/ModalActivity";
import ModalTools from "../ModalTools";
import ProtectedRoute from "../ProtectedRoute";
import QuestionListCreate from "../QuestionListCreate";
import QuestionListImportModal from "../QuestionListImportModal/QuestionListImportModal";
import RichText from "../RichText/SlateEditor/Editor";
import Uploader from "../Uploader/uploader";
import UploadModal from "../UploadModal";
import Widgets from "../Widgets/Widgets";

import "../CriadorDeTrilha/criadorDeTrilha.css";

const FileDownload = require("js-file-download");

class ActivityCreate extends Component {
  constructor(props) {
    super(props);

    // Atividade criada a partir de "Minhas trilhas" (/activity/create?trail=true):
    // execução sequencial e disponibilidade travadas. O COMPONENTE CURRICULAR
    // não: ele é escolhido como em qualquer atividade (05/10/2026).
    this.isTrailActivity = isTrailQueryActive(props.location?.search);

    this.labels = this.isTrailActivity
      ? {
          entidade: "Trilha",
          criarSubtitulo: "Crie uma nova trilha",
          editarSubtitulo: "Edite a trilha",
          nomeLabel: "Nome da trilha",
          nomePlaceholder: "Nome da Trilha",
          objetosInstrucao:
            "Clique nos objetos que você deseja inserir na sua trilha",
          dropName: "Selecione e organize aqui os objetos/passos da trilha",
          semComponente: "poder adicionar os passos da trilha.",
          listaExercicioUnica:
            "Você só pode adicionar uma lista de exercício na trilha.",
          minimoPassos: `Uma trilha precisa de pelo menos ${TRILHA_MIN_OBJETOS} passos.`
        }
      : {
          entidade: "Atividade",
          criarSubtitulo: "Crie uma nova atividade",
          editarSubtitulo: "Edite a atividade",
          nomeLabel: "Nome da atividade",
          nomePlaceholder: "Nome da Atividade",
          objetosInstrucao:
            "Clique nos objetos que você deseja inserir na sua atividade",
          dropName: "Atividades selecionadas",
          semComponente: "poder adicionar atividades.",
          listaExercicioUnica:
            "Você só pode adicionar uma lista de exercício na atividade.",
          // Atividade comum não tem piso de objetos; a chave existe para os dois
          // mapas terem o mesmo formato.
          minimoPassos: null
        };

    this.state = {
      loading: true,
      showAllTypes: false,
      edit: false,
      fase: 1,
      fases: 2,
      name: "",
      isPrivate: true,
      description: "",
      disciplineIds: [],
      disciplinesSelected: [],
      disciplinesList: [],
      activity_type: "",
      types: [],
      sequential_execution: this.isTrailActivity,
      // Região da trilha lúdica. Só existe no modo trilha, e só é ENVIADA na
      // criação — ver `enviarRegiao` e TRILHA_REGIAO_TRAVADA_AVISO.
      trailRegion: TRILHA_REGIAO_PADRAO,
      // A descrição da trilha nasce compacta (96px) e o professor expande se
      // precisar. Só o modo trilha lê isto.
      descricaoExpandida: false,
      modal: false,
      creating: false,
      modalProps: {
        modalCompoent: 1,
        title: "",
        type: 0,
        typeName: ""
      },
      contentList: [],
      textProduction: {
        id: "",
        name: "",
        group: false,
        type: "",
        criterion: [],
        note: 0
      },
      linkModal: false,
      textModal: false,
      // `uploadModal` cria a vaga de entrega (UploadCreator);
      // `uploadPreviewModal` só mostra a vaga já criada. Eram a mesma flag, e
      // por isso clicar num Upload da pré-visualização abria o formulário de
      // criação e podia acrescentar um conteúdo novo à atividade.
      uploadModal: false,
      uploadPreviewModal: false,
      fileModal: false,
      editing: false,
      editIndex: -1,
      criterions: [],
      newTextProductionCriterion: "",
      textTypes: [],
      result_type: "SEMPRE",
      showViewModal: false,
      activity: {
        activity_start: "",
        activity_end: "",
        notDefined: "Atividade ainda não alocada"
      },
      modalTool: false,
      toolName: null,
      toolId: null,
      item_id: null,
      listQuestion: {
        id: "",
        show: false,
        average: 0
      },
      formularioPreview: {
        show: false,
        loading: false,
        formulario: null
      },
      contentId: null,
      contentName: null,
      iframe: false,
      textProductionViewer: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      ValorDescricao: null,
      currentLOLink: null,
      series: [],
      serie_selected: null,
      seriesSelectList: [],
      abilitiesSelected: [],
      abilitiesSelectList: [],
      uploadFileModal: false,
      selectedActivityFile: null,
      viewMode: false,
      evaluationStatisticsModal: false
    };

    this.error = this.error.bind(this);
  }

  /* Id do tipo de conteúdo "Formulário" nesta base, achado pelo nome (ver
     config/formularios.js). null enquanto os tipos não chegaram. */
  formularioTypeId = () =>
    this.state.types.find(type => isTipoFormulario(type.name))?.id ?? null;

  isFormularioType = typeId =>
    typeId !== null &&
    typeId !== undefined &&
    Number(typeId) === Number(this.formularioTypeId());

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  setValorDescrição(val) {
    this.setState({
      ValorDescricao: val
    });
  }

  componentDidMount() {
    const inputFields = document.querySelectorAll("input");
    inputFields.forEach(input => {
      input.setAttribute("readonly", "readonly");
    });

    setTimeout(() => {
      inputFields.forEach(input => {
        input.removeAttribute("readonly");
      });
    }, 2000);

    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.trailModal
      ? this.props
      : this.props?.match?.params || {};
    const objDisciplinesList = { user_id: this.props.user.user.id };
    const objCriterionsList = { user_id: this.props.user.user.id };

    axios
      .all([
        axios.get(`${URL.api}content/type/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}community/room_user/list`, objDisciplinesList, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}activity/type/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/discipline/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}literarte/text_types`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}literarte/criterions`, objCriterionsList, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/serie/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (
            respType,
            respRoomUser,
            respActivityType,
            respDiscipline,
            respTextTypes,
            respTextCriterions,
            respSeries
          ) => {
            if (respType.data.success && respActivityType.data.success) {
              let textTypesList = [];
              respTextTypes.data.data.forEach(type => {
                textTypesList.push(type);
              });

              let textCriterionsList = [];
              respTextCriterions.data.data[0].forEach(criterion => {
                criterion.visible = true;
                textCriterionsList.push(criterion);
              });

              respTextCriterions.data.data[1].forEach(criterion => {
                criterion.visible = true;
                textCriterionsList.push(criterion);
              });

              let types = [];
              respType.data.data.forEach(type => {
                if (type.id === 24) {
                  return;
                }
                if (type.activity === true) {
                  if (type.name === "Avaliação") {
                    type.name = "Exercício";
                  }
                  if (type.id === 24) {
                    return;
                  }
                  if (!this.props.general.active_roles.group_id) {
                    types.push(type);
                  } else if (
                    type.id === 9 &&
                    this.props.user.user_modules?.find(
                      module => module.id === 11
                    )
                  ) {
                    types.push(type);
                  } else if (
                    this.props.user.user_modules?.find(
                      module => module.id === 2
                    )
                  ) {
                    types.push(type);
                  } else if (
                    type.id === 18 ||
                    type.id === 12 ||
                    isTipoFormulario(type.name)
                  ) {
                    types.push(type);
                  }
                }
              });

              let disciplinesList = [];

              if (
                ["G", "U", "R", "E"].includes(
                  this.props.general.active_roles.type
                )
              ) {
                disciplinesList = respDiscipline.data.data.map(discipline => ({
                  value: discipline.id,
                  label: discipline.name
                }));
              } else {
                let check;
                for (let i = 0; i < respRoomUser.data.data.length; i++) {
                  for (
                    let j = 0;
                    j < respRoomUser.data.data[i]?.disciplines?.length;
                    j++
                  ) {
                    check = true;

                    if (
                      respRoomUser.data.data[i].id ===
                      respRoomUser.data.data[i].disciplines[j].room_user_id
                    ) {
                      for (let k = 0; k < disciplinesList.length; k++) {
                        if (
                          disciplinesList[k].value ===
                          respRoomUser.data.data[i].disciplines[j].discipline_id
                        ) {
                          check = false;
                          break;
                        }
                      }

                      if (check) {
                        disciplinesList.push({
                          value:
                            respRoomUser.data.data[i].disciplines[j]
                              .discipline_id,
                          label:
                            respRoomUser.data.data[i].disciplines[j]
                              .discipline_name
                        });
                      }
                    }
                  }
                }

                if (disciplinesList.length === 0) {
                  disciplinesList = respDiscipline.data.data.map(
                    discipline => ({
                      value: discipline.id,
                      label: discipline.name
                    })
                  );
                }
              }

              const series = respSeries.data.data;
              const seriesSelectList = [
                { value: null, label: "Selecionar" },
                ...series.map(serie => ({
                  value: serie.id,
                  label: serie.name
                }))
              ];

              this.setState({
                types,
                disciplinesList,
                activity_type: "1",
                criterions: textCriterionsList,
                textTypes: textTypesList,
                series,
                seriesSelectList
              });

              if (id) {
                this.setState(
                  () => ({
                    edit: true
                  }),
                  () => {
                    axios
                      .get(`${URL.api}activity/activity/singleView/${id}`, {
                        headers: {
                          authorization: `Bearer ${this.props.user.token}`
                        }
                      })
                      .then(respActivity => {
                        let contentList = [];
                        for (
                          let i = 0;
                          i < respActivity.data.data.items.length;
                          i++
                        ) {
                          let obj = {
                            type: respActivity.data.data.items[i].type_id,
                            list: {
                              id: respActivity.data.data.items[i].obj_id,
                              name: respActivity.data.data.items[i].name
                            },
                            link: respActivity.data.data.items[i].link,
                            path: respActivity.data.data.items[i].content_path
                          };
                          contentList.push(obj);
                        }

                        let types = [];
                        if (respActivity.data.data.type_id === 3) {
                          this.state.types.forEach(type => {
                            if (type.id === 12) {
                              types.push(type);
                            }
                          });
                        } else {
                          this.state.types.forEach(type => {
                            types.push(type);
                          });
                        }

                        // Este é o caminho da EDIÇÃO, e era o segundo lugar onde a
                        // descrição derrubava a tela: uma trilha criada sem descrição
                        // tem `description` NULL no banco, e o `substring` estourava
                        // antes de qualquer campo ser preenchido — a tela de editar
                        // trilha simplesmente não abria. Ver `utils/descricaoAtividade.js`
                        // para os quatro formatos que o campo assume.
                        //
                        // O `"paragaph"` (sem o "r") é o tipo que este arquivo sempre
                        // gravou, e ele vai ao banco dentro do JSON da descrição.
                        // Renderiza igual a `"paragraph"` — nenhum dos dois tem `case`
                        // no switch de `SlateUtilityFunctions`, ambos caem no
                        // `default` —, então trocar mexeria no dado gravado sem mudar
                        // nada na tela.
                        const nosDaDescricao = descricaoParaEditor(
                          respActivity.data.data.description,
                          "paragaph"
                        );
                        // Só reescreve quando o campo NÃO estava no formato do editor,
                        // como antes: re-serializar um JSON que já estava certo trocaria
                        // o valor por um equivalente, sem motivo.
                        if (
                          !temFormatoDeEditor(
                            respActivity.data.data.description
                          )
                        ) {
                          respActivity.data.data.description =
                            JSON.stringify(nosDaDescricao);
                        }
                        this.setValorDescrição(nosDaDescricao);

                        const disciplineIds =
                          respActivity.data.data?.disciplines?.map(
                            discipline => discipline.id
                          );
                        (async () => {
                          let abilitiesSelectList = [];
                          const abilitiesPromises = disciplineIds?.map(
                            disciplineId =>
                              axios.get(
                                `${
                                  URL.api
                                }classification/ability/moduleAbilityByDiscipline/${disciplineId}/${
                                  this.state.serie_selected ?? 0
                                }`,
                                {
                                  headers: {
                                    authorization: `Bearer ${this.props.user.token}`
                                  }
                                }
                              )
                          );

                          if (!abilitiesPromises) return;

                          const abilitiesResponses = await Promise.all(
                            abilitiesPromises
                          );

                          abilitiesResponses?.forEach(respAbilities => {
                            abilitiesSelectList.push(
                              ...respAbilities.data.data.abilities.map(
                                ability => ({
                                  value: ability.id,
                                  label: `${ability.code} - ${ability.description}`
                                })
                              )
                            );
                          });

                          this.setState({ abilitiesSelectList });
                        })();

                        const serieSelected = series.find(
                          serie => serie.id === respActivity.data.data.serie_id
                        );

                        this.setState(() => ({
                          loading: false,
                          name: respActivity.data.data.name,
                          description: respActivity.data.data.description,
                          serie_selected: {
                            value: serieSelected?.id,
                            label: serieSelected?.name
                          },
                          disciplineIds: disciplineIds ?? [],
                          abilitiesSelected:
                            respActivity.data.data?.abilities?.map(
                              discipline => ({
                                value: discipline.ability_id,
                                label: discipline.code
                              })
                            ) ?? [],
                          disciplinesSelected:
                            respActivity.data.data?.disciplines?.map(
                              discipline => ({
                                value: discipline.id,
                                label: discipline.name
                              })
                            ) ?? [],
                          isPrivate: respActivity.data.data.private,
                          activity_type: respActivity.data.data.type_id,
                          contentList,
                          sequential_execution:
                            respActivity.data.data.sequential_execution,
                          result_type: respActivity.data.data.result_type,
                          disciplinesList,
                          file: respActivity.data.data?.file,
                          criterions: textCriterionsList,
                          textTypes: textTypesList,
                          series,
                          seriesSelectList
                        }));
                      });
                  }
                );
              } else {
                this.setState({
                  loading: false
                });
              }
            }
          },
          error => {
            this.error(error.response.statusText);
          }
        )
      );

    if (this.state.edit) {
      this.updateContentList();
    }
  }

  previous() {
    this.setState(state => ({
      fase: Math.max(1, state.fase - 1)
    }));
  }

  next() {
    this.setState(state => ({
      fase: Math.min(state.fases, state.fase + 1)
    }));
  }

  getAtualFase = fase => {
    this.setState({
      fase
    });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  changeName = e => {
    let { value } = e.target;
    this.setState({
      name: value
    });
  };

  changeRegiaoDaTrilha = regiaoId => {
    // Recebe o ID direto desde que a escolha virou cartão (antes vinha a opção
    // inteira do react-select). O `||` continua valendo: sem escolha, volta para
    // a padrão em vez de ficar sem região — o backend cairia nela de qualquer
    // forma, e deixar o campo vazio mentiria sobre o que vai ser salvo.
    this.setState({ trailRegion: regiaoId || TRILHA_REGIAO_PADRAO });
  };

  changeSerie = async selectedSerie => {
    if (selectedSerie?.value) {
      this.setState({
        serie_selected: selectedSerie,
        abilitiesSelectList: [],
        abilitiesSelected: []
      });

      const segmentId = this.state.series.find(
        serie => serie.id === selectedSerie.value
      ).segment_id;

      let abilitiesSelectList = [];

      const abilitiesPromises = this.state.disciplineIds.map(disciplineId =>
        axios.get(
          `${URL.api}classification/ability/moduleAbilityByDiscipline/${disciplineId}/${segmentId}`,
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        )
      );

      const abilitiesResponses = await Promise.all(abilitiesPromises);

      abilitiesResponses.forEach(respAbilities => {
        abilitiesSelectList.push(
          ...respAbilities.data.data.abilities.map(ability => ({
            value: ability.id,
            label: `${ability.code} - ${ability.description}`
          }))
        );
      });

      this.setState({ abilitiesSelectList });
    }
  };

  changeDescription = e => {
    let { value } = e.target;
    this.setState({
      description: value
    });
  };

  changePrivate = newValue => {
    this.setState({
      isPrivate: newValue
    });
  };

  changeDiscipline = async disciplinesSelected => {
    let disciplineIds = disciplinesSelected.map(discipline => discipline.value);
    this.setState({ disciplineIds, disciplinesSelected });

    if (disciplineIds.length === 0) {
      this.setState({
        serie_selected: null,
        abilitiesSelected: [],
        abilitiesSelectList: []
      });
      return;
    }

    const segmentId =
      this.state.series.find(
        serie => serie.id === this.state.serie_selected?.value
      )?.segment_id ?? 0;

    let abilitiesSelectList = [];

    // Usa o disciplineIds local: this.state ainda não refletiu o setState
    // acima, então na primeira seleção ele estaria vazio e nenhuma
    // habilidade seria carregada.
    // E serie_selected é o objeto { value, label } do react-select — sem o
    // .value a URL saía como .../[object Object] e o backend devolvia 500.
    const segmentParam = this.state.serie_selected?.value ?? 0;

    const abilitiesPromises = disciplineIds.map(disciplineId =>
      axios.get(
        `${URL.api}classification/ability/moduleAbilityByDiscipline/${disciplineId}/${segmentParam}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
    );

    const abilitiesResponses = await Promise.all(abilitiesPromises);

    abilitiesResponses.forEach(respAbilities => {
      abilitiesSelectList.push(
        ...respAbilities.data.data.abilities.map(ability => ({
          value: ability.id,
          label: `${ability.code} - ${ability.description}`
        }))
      );
    });

    this.setState({
      abilitiesSelectList
    });
  };

  changeAbilities = abilitiesSelected => {
    const aux = abilitiesSelected.map(ability => ({
      value: ability.value,
      label: ability.label.split(" ")[0]
    }));
    this.setState({ abilitiesSelected: aux });
  };

  getOrder = order => {
    this.setState({
      contentList: order
    });
  };

  getSelected = selected => {
    this.setState({});
  };

  selectedItem = item => {
    if (item.id === "ver_todos") {
      this.setState({ showAllTypes: true });
      return null;
    }
    this.setState(
      prevState => {
        let contentList = [...prevState.contentList];

        const itemExists = contentList.some(
          existingItem =>
            existingItem.type === item.id && existingItem.list.id === item.id
        );

        if (itemExists && !prevState.editing) {
          toastr.error("Erro", `O conteúdo "${item.name}" já foi adicionado.`);
          return null;
        }

        if (prevState.editing && prevState.editIndex !== -1) {
          if (
            item.id < 12 ||
            item.id === 12 ||
            item.id === 14 ||
            this.isFormularioType(item.id)
          ) {
            return {
              modalProps: {
                ...prevState.modalProps,
                modalCompoent: 1,
                type: item.id,
                typeName: item.name,
                title: `Selecione - ${item.name}`
              }
            };
          }
          if (item.id === 16) {
            return { linkModal: true };
          }
          if (item.id === 33) {
            return { textModal: true };
          }
          if (item.id === 17) {
            return { fileModal: true };
          }
          if (item.id === 18) {
            return { uploadModal: true };
          }
          const updatedContentList = contentList.map((content, idx) =>
            idx === prevState.editIndex
              ? { type: item.id, list: { id: item.id, name: item.name } }
              : content
          );
          return {
            contentList: updatedContentList,
            editing: false,
            editIndex: -1
          };
        }
        if (item.id < 12) {
          return {
            modalProps: {
              ...prevState.modalProps,
              modalCompoent: 1,
              type: item.id,
              typeName: item.name,
              title: `Selecione - ${item.name}`
            }
          };
        }
        if (item.id === 12) {
          // Atividade comum aceita só uma lista de exercício, porque boa parte
          // do backend resolve "a lista da atividade" no singular. Na trilha
          // cada passo pode ser uma lista, e o item_id é enviado
          // explicitamente para desambiguar
          // (ver docs/trilhas-multiplos-exercicios.md).
          if (!this.isTrailActivity) {
            let check = true;
            for (let i = 0; i < contentList.length; i++) {
              if (contentList[i].type === 12) {
                check = false;
                toastr.error("Erro", this.labels.listaExercicioUnica);
                break;
              }
            }
            if (!check) return null;
          }

          return {
            modalProps: {
              ...prevState.modalProps,
              modalCompoent: 1,
              type: item.id,
              typeName: item.name,
              title: `Selecione - ${item.name}`
            }
          };
        }
        if (item.id === 14 || this.isFormularioType(item.id)) {
          return {
            modalProps: {
              ...prevState.modalProps,
              modalCompoent: 1,
              type: item.id,
              typeName: item.name,
              title: `Selecione - ${item.name}`
            }
          };
        }
        if (item.id === 16) {
          return { linkModal: true };
        }
        if (item.id === 33) {
          return { textModal: true };
        }
        if (item.id === 17) {
          return { fileModal: true };
        }
        if (item.id === 18) {
          return { uploadModal: true };
        }
        return {
          contentList: [
            ...contentList,
            { type: item.id, list: { id: item.id, name: item.name } }
          ]
        };
      },
      () => {
        if (
          item.id < 12 ||
          item.id === 12 ||
          item.id === 14 ||
          this.isFormularioType(item.id)
        ) {
          this.toggleModal();
        }
      }
    );
  };

  selectedListItem = list => {
    this.setState(
      prevState => {
        let contentList = [...prevState.contentList];

        let obj = {
          type: 12,
          list: {
            id: list.id,
            name: list.name
          }
        };

        if (prevState.editing && prevState.editIndex !== -1) {
          contentList.splice(prevState.editIndex, 1, obj);
        } else {
          contentList.push(obj);
        }

        return {
          contentList,
          editListId: null,
          editing: false,
          editIndex: -1
        };
      },
      () => {
        this.toggleModal();
      }
    );
  };

  /* Formulário escolhido no FormularioPicker. Diferente dos objetos comuns, o
     mesmo formulário pode aparecer uma vez só por atividade: cada aluno
     responde uma vez, e dois itens iguais nunca poderiam ser concluídos. */
  selectedFormularioItem = formulario => {
    if (
      !this.state.editing &&
      this.state.contentList.some(
        content =>
          this.isFormularioType(content.type) &&
          Number(content.list.id) === Number(formulario.id)
      )
    ) {
      toastr.error(
        "Erro",
        `O formulário "${formulario.titulo}" já foi adicionado.`
      );
      return;
    }

    this.setState(
      prevState => {
        const contentList = [...prevState.contentList];
        const item = {
          type: this.formularioTypeId(),
          list: { id: formulario.id, name: formulario.titulo }
        };

        if (prevState.editing && prevState.editIndex !== -1) {
          contentList.splice(prevState.editIndex, 1, item);
        } else {
          contentList.push(item);
        }

        return { contentList, editing: false, editIndex: -1 };
      },
      () => {
        this.toggleModal();
      }
    );
  };

  editItem = (type, id, item) => {
    const editIndex = this.state.contentList.findIndex(
      item => item.type === type && item.list.id === id
    );

    if (type === 12) {
      this.setState(
        {
          editListId: id,
          newList: true,
          editing: true,
          editIndex
        },
        () => this.selectedItem(item)
      );
    } else {
      this.setState(
        {
          editing: true,
          editIndex,
          currentLOLink: id
        },
        () => this.selectedItem(item)
      );
    }
  };

  removeItem = (type, id) => {
    this.setState(prevState => {
      const contentList = prevState.contentList.filter(
        item => item.type !== type || item.list.id !== id
      );
      return { contentList };
    });
  };

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  };

  getContent = content => {
    this.setState(
      prevState => {
        let contentList = [...prevState.contentList];

        const itemsToAdd = Array.isArray(content.list)
          ? content.list
          : [content.list];

        for (let i = 0; i < itemsToAdd.length; i++) {
          let currentItem = itemsToAdd[i];
          let obj = {
            type: content.type,
            list: currentItem
          };

          let check = true;
          for (let j = 0; j < contentList.length; j++) {
            if (
              content.type === contentList[j].type &&
              currentItem.id === contentList[j].list.id
            ) {
              check = false;
              toastr.error(
                "Erro",
                `O conteúdo "${currentItem.name}" já tinha sido adicionado antes.`
              );
              break;
            }
          }

          if (check) {
            if (prevState.editing && prevState.editIndex !== -1) {
              contentList.splice(prevState.editIndex, 1, obj);
              return { contentList, editing: false, editIndex: -1 };
            }
            contentList.push(obj);
          }
        }

        let typeMap = {};
        prevState.types.forEach(item => {
          typeMap[item.id] = {
            title: item.name,
            type_icon: item.icon,
            type_color: item.color
          };
        });

        contentList.forEach(lo => {
          const typeInfo = typeMap[lo.type];
          if (typeInfo) {
            lo.list.subtitle = typeInfo.title;
            lo.list.title = lo.list.name;
            lo.list.type_icon = typeInfo.type_icon;
            lo.list.type_id = lo.type;
            lo.list.type_color = typeInfo.type_color;
          }
        });

        return { contentList };
      },
      () => {
        if (![16, 18, 33].includes(content.type)) {
          this.toggleModal();
        }
      }
    );
  };

  doneArchive = (uploads, name) => {
    this.setState(prevState => {
      let contentList = [...prevState.contentList];

      let obj = {
        type: 17,
        list: {
          id: uploads.split("/").reverse()[1].toLowerCase() === "repo" ? 0 : 1,
          name: name || uploads.split("/").reverse()[0]
        },
        link: uploads
      };

      if (prevState.editing) {
        contentList.splice(prevState.editIndex, 1, obj);
      } else {
        contentList.push(obj);
      }

      return {
        contentList,
        editing: false,
        editIndex: -1
      };
    });
  };

  changeTextProductionName = e => {
    let { value } = e.target;
    this.setState(prevState => ({
      textProduction: {
        ...prevState.textProduction,
        name: value
      }
    }));
  };

  changeTextProductionNote = e => {
    let { value } = e.target;
    this.setState(prevState => ({
      textProduction: {
        ...prevState.textProduction,
        note: value
      }
    }));
  };

  changeTextProductionCriterionNote = (e, i) => {
    let { value } = e.target;

    this.setState(prevState => {
      let criterions = prevState.textProduction.criterion.map(
        (criterion, index) => {
          if (i === index) {
            return { ...criterion, note: value };
          }
          return criterion;
        }
      );

      return {
        textProduction: {
          ...prevState.textProduction,
          criterion: criterions
        }
      };
    });
  };

  changeTextProductionCriterion = e => {
    let { value } = e.target;

    this.setState(prevState => {
      let criterions = [...prevState.textProduction.criterion];

      let criterionsState = prevState.criterions.map(criterion => {
        if (criterion.id === parseInt(value)) {
          criterions.push({ ...criterion, note: 0 });
          return { ...criterion, visible: false };
        }
        return criterion;
      });

      return {
        criterions: criterionsState,
        textProduction: {
          ...prevState.textProduction,
          criterion: criterions
        }
      };
    });
  };

  removeTextProductionCriterion = id => {
    this.setState(prevState => {
      let criterions = prevState.textProduction.criterion.filter(
        criterion => criterion.id !== id
      );

      let criterionsState = prevState.criterions.map(criterion => {
        if (criterion.id === id) {
          return { ...criterion, visible: true };
        }
        return criterion;
      });

      return {
        criterions: criterionsState,
        textProduction: {
          ...prevState.textProduction,
          criterion: criterions
        }
      };
    });
  };

  createTextProduction = () => {
    let check = true;
    if (this.state.textProduction.name === "") {
      toastr.error("Erro", "O campo título não pode ser vazio.");
      check = false;
    }

    if (this.state.textProduction.note === 0) {
      toastr.error("Erro", "O campo nota não pode ser 0.");
      check = false;
    }

    if (this.state.textProduction.type === "") {
      toastr.error("Erro", "O campo tipo não pode ser vazio.");
      check = false;
    }

    if (this.state.textProduction.criterion.length === 0) {
      toastr.error("Erro", "O campo critério não pode ser vazio.");
      check = false;
    }

    let count = 0;
    this.state.textProduction.criterion.forEach(criterion => {
      count += Number(criterion.note.toString().replace(",", "."));
    });

    if (
      count !==
      Number(this.state.textProduction.note.toString().replace(",", "."))
    ) {
      toastr.error(
        "Erro",
        "A soma das notas dos critérios tem que ser igual a nota geral."
      );
      check = false;
    }

    if (check) {
      let obj = {
        user_id: this.props.user.user.id,
        title: this.state.textProduction.name,
        text_type_id: this.state.textProduction.type,
        note: this.state.textProduction.note,
        criterions: this.state.textProduction.criterion
      };

      axios
        .post(`${URL.api}literarte/activity_create`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            this.setState(
              prevState => {
                let contentList = [...prevState.contentList];

                if (prevState.editing && prevState.editIndex !== -1) {
                  contentList.splice(prevState.editIndex, 1, {
                    type: 14,
                    list: {
                      id: resp.data.data,
                      name: prevState.textProduction.name
                    }
                  });
                } else {
                  contentList.push({
                    type: 14,
                    list: {
                      id: resp.data.data,
                      name: prevState.textProduction.name
                    }
                  });
                }

                return {
                  textProduction: {
                    ...prevState.textProduction,
                    id: resp.data.data
                  },
                  contentList,
                  editing: false,
                  editIndex: -1
                };
              },
              () => {
                this.toggleModal();
              }
            );
          }
        });
    }
  };

  saveActivity = () => {
    const {
      name,
      ValorDescricao,
      isPrivate,
      serie_selected,
      disciplineIds,
      contentList,
      result_type,
      sequential_execution,
      abilitiesSelected,
      edit
    } = this.state;
    const { user } = this.props.user;

    const trimmedName = name.trim();
    const abilitiesIds = (abilitiesSelected ?? []).map(ability =>
      typeof ability === "object" ? ability.value : ability
    );

    // `JSON.stringify(undefined)` é `undefined` e `JSON.stringify(null)` é a
    // STRING "null" — que é o que vai para o banco quando ninguém escreve
    // descrição, e volta para o editor como conteúdo literal.
    //
    // A correção vale SÓ NA TRILHA, de propósito: atividade e avaliação gravam
    // assim desde sempre, e há acervo inteiro com "null" no campo. Mudar o que
    // elas enviam é outra decisão, com outro teste — não carona desta.
    const descricaoSerializada = JSON.stringify(ValorDescricao);
    const descricao =
      this.isTrailActivity &&
      (!descricaoSerializada || descricaoSerializada === "null")
        ? ""
        : descricaoSerializada;

    let obj = {
      name: trimmedName,
      description: descricao,
      user_id: user.id,
      // Na trilha os dois campos não têm controle na tela (ver o render), mas
      // CONTINUAM no payload, e com valor. `ActivityController@insert` não
      // valida nada e passa o que recebe para `Activity::create`: um `null`
      // explícito numa coluna `boolean not null default false` não cai no
      // default — derruba o insert inteiro por rollback, e a tela recebe um 200
      // sem id. Uma trilha é sempre privada e sempre sequencial (é o sequencial
      // que faz um nó bloquear o seguinte).
      private: this.isTrailActivity ? true : isPrivate,
      serie_id: serie_selected?.value,
      discipline_id: disciplineIds?.[0]?.toString(),
      disciplines: disciplineIds,
      items: contentList,
      type_id: 1,
      result_type,
      sequential_execution: this.isTrailActivity ? true : sequential_execution,
      abilities: abilitiesIds,
      is_trail: this.isTrailActivity || null
    };

    // A região vai só na CRIAÇÃO. `LudicTrailSetting::store` é `firstOrCreate`, ou
    // seja o backend nunca trocaria uma região existente — mas esta tela não SABE
    // qual é a região de uma trilha que já existe (`singleView` não a devolve),
    // então mandar o valor do estado numa edição gravaria a padrão em cima de uma
    // trilha cuja gravação original tenha falhado. Errar para o lado de não mandar.
    if (this.isTrailActivity && !edit) {
      obj.trail_region = this.state.trailRegion;
    }

    const emptyFields = [];
    if (!obj.disciplines || obj.disciplines.length === 0)
      emptyFields.push("Selecione um componente curricular!");
    if (obj.items.length === 0)
      emptyFields.push("Selecione pelo menos um conteúdo!");
    // Piso de passos da trilha. Só é cobrado quando há ALGUM item: com a lista
    // vazia o aviso acima já é o certo, e dois toasts sobre a mesma coisa fazem
    // o professor procurar dois problemas.
    if (
      this.isTrailActivity &&
      obj.items.length > 0 &&
      !temPassosSuficientes(obj.items.length)
    )
      emptyFields.push(this.labels.minimoPassos);
    // Um item sem list.id viraria obj_id nulo em activity_items, e o insert
    // inteiro seria revertido no backend devolvendo 200 sem o id da atividade.
    // Melhor barrar aqui, dizendo qual item está incompleto.
    const invalidItems = obj.items.filter(item => !item?.list?.id);
    if (invalidItems.length > 0)
      emptyFields.push(
        `Não foi possível identificar ${
          invalidItems.length === 1
            ? "1 objeto"
            : `${invalidItems.length} objetos`
        } da lista. Remova e adicione novamente.`
      );
    if (!obj.type_id) emptyFields.push("Selecione um tipo");
    if (!obj.name) emptyFields.push("Campo nome está vazio!");
    if (obj.private === undefined || obj.private === null)
      emptyFields.push("Campo de visibilidade está vazio!");

    if (emptyFields.length > 0) {
      emptyFields.forEach(field => toastr.error("Erro", field));
      return;
    }

    this.setState({ creating: true });
    if (edit) {
      this.editActivity(obj);
    } else {
      this.createActivity(obj);
    }
  };

  createActivity = async obj => {
    try {
      const insertResponse = await axios.post(
        `${URL.api}activity/activity/insert`,
        obj,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      // O insert devolve 200 mesmo quando faz rollback: nesse caso vem
      // { success: false, error } e sem o id. Sem esta checagem a tela
      // navegava para /activity/create/undefined e disparava requests com
      // "undefined" no lugar do id.
      if (!insertResponse.data?.success || !insertResponse.data?.data) {
        toastr.error(
          "Erro",
          insertResponse.data?.error ||
            "Não foi possível salvar a atividade. Tente novamente."
        );
        this.setState({ creating: false });
        return;
      }

      if (this.state.fileUploaded) {
        const fileUpload = {
          activity_id: insertResponse.data.data,
          name: this.state.fileUploaded.name,
          link: URL.public + this.state.fileUploaded.url
        };

        await axios.post(`${URL.api}activity/activity/insertFile`, fileUpload, {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        });
      }

      if (this.props.trailModal) {
        const trailActivityResponse = await axios.get(
          `${URL.api}activity/trail/showActivity/${insertResponse.data.data}`,
          {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }
        );
        this.props.onCreate(trailActivityResponse.data.data);
      } else if (this.state.activity_type === 3) {
        this.props.history.push(
          `/activity/tv/share/${insertResponse.data.data}`
        );
      } else {
        // Propaga o modo trilha para a alocação, senão a tela seguinte se
        // comporta (e se rotula) como uma atividade comum.
        this.props.history.push(
          `/activity/allocate/${insertResponse.data.data}${
            this.isTrailActivity ? "?trail=true" : ""
          }`
        );
      }

      if (!this.props.trailModal) {
        window.history.pushState(
          {},
          "",
          `/activity/create/${insertResponse.data.data}${
            this.isTrailActivity ? "?trail=true" : ""
          }`
        );
      }
    } catch (error) {
      this.setState({ creating: false });
    }
  };

  editActivity = async obj => {
    try {
      obj.id = this.props.trailModal
        ? this.props?.id
        : this.props?.match?.params?.id;

      const updateResponse = await axios.post(
        `${URL.api}activity/activity/update`,
        obj,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      if (this.props.trailModal) {
        const trailActivityResponse = await axios.get(
          `${URL.api}activity/trail/showActivity/${updateResponse.data.data.id}`,
          {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }
        );
        this.props.onEdit(trailActivityResponse.data.data);
      } else if (this.state.activity_type === 3) {
        this.props.history.push(`/activity/tv/share/${obj.id}`);
      } else {
        this.props.history.push(`/activity/allocate/${obj.id}`);
      }

      this.setState({ creating: false });
    } catch (error) {
      this.setState({ creating: false });
    }
  };

  changeNewTextProductionCriterion = e => {
    let name = e.target.value;
    this.setState({
      newTextProductionCriterion: name
    });
  };

  createTextProductionCriterion = () => {
    let obj = {
      name: this.state.newTextProductionCriterion,
      user_id: this.props.user.user.id
    };
    axios
      .post(`${URL.api}literarte/criterion_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState(prevState => {
            let textProductionCriterions = [
              ...prevState.textProduction.criterion
            ];

            textProductionCriterions.push({
              id: resp.data.data,
              name: obj.name,
              user_id: this.props.user.user.id,
              value: 0
            });

            let criterions = [...prevState.criterions];
            criterions.push({
              id: resp.data.data,
              name: obj.name,
              user_id: this.props.user.user.id,
              visible: false
            });

            return {
              newTextProductionCriterion: "",
              textProduction: {
                ...prevState.textProduction,
                criterion: textProductionCriterions
              },
              criterions
            };
          });
        }
      });
  };

  disableLiterarteModal = () => {
    this.setState(prevState => ({
      textProductionViewer: {
        ...prevState.textProductionViewer,
        show: false
      },
      item_id: prevState.textProductionViewer.item_id,
      contentName: prevState.textProductionViewer.contentName
    }));
  };

  fecharPreviaFormulario = () =>
    this.setState({
      formularioPreview: { show: false, loading: false, formulario: null },
      showViewModal: true
    });

  openItem = itemAux => {
    let item = itemAux.list;
    this.setState({ showViewModal: false, viewMode: true });
    const late = Date.parse(this.state.activity.activity_end) < Date.now();

    if (this.isFormularioType(itemAux.type)) {
      this.setState({
        formularioPreview: { show: true, loading: true, formulario: null },
        contentName: itemAux.list.name
      });
      axios
        .get(`${URL.api}formulario/${itemAux.list.id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(response => {
          this.setState({
            formularioPreview: {
              show: true,
              loading: false,
              formulario: response.data?.data || null
            }
          });
        })
        .catch(error => {
          toastr.error(
            "Erro",
            error.response?.data?.error ||
              "Não foi possível visualizar o formulário."
          );
          this.fecharPreviaFormulario();
        });
    } else if (itemAux.type === 12) {
      this.setState({
        listQuestion: {
          id: itemAux.list.id,
          show: true
        },
        contentId: itemAux.list.id,
        contentName: itemAux.list.name,
        item_id: itemAux.list.id
      });
    } else if (itemAux.type === 33) {
      this.setState({ currentLOLink: item.id, textModal: true });
    } else if (itemAux.type === 15) {
      this.setState({
        modalTool: true,
        toolId: itemAux.type,
        toolName: itemAux.list.name,
        item_id: itemAux.list.id,
        contentName: itemAux.list.name
      });
    } else if (itemAux.type === 16 || itemAux.type === 27) {
      axios
        .get(`${URL.api}content/los/singleView/${itemAux.list.id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            let url = caminhoDoLo(resp);

            if (url.indexOf("http://") === 0) {
              url.replace("http://", "");
            } else if (url.indexOf("https://") === 0) {
              url.replace("https://", "");
            } else {
              url = `https://${url}`;
            }
            window.open(url, "_blank").focus();
          },
          () => {
            toastr.error(
              "Falha",
              "Não foi possível abrir o link. Tente novamente!"
            );
          }
        );
    } else if (itemAux.type === 14) {
      this.setState(prevState => ({
        textProductionViewer: {
          ...prevState.textProductionViewer,
          show: true,
          id: itemAux.list.id
        },
        item_id: itemAux.list.id,
        contentName: itemAux.list.name
      }));
    } else if (itemAux.type === 18) {
      // Esta tela é do professor montando a atividade: não há execução, logo
      // nada de nota nem de entrega — só a conferência da vaga. O id do
      // conteúdo vem de `list.id` (o obj_id lido no singleView da atividade).
      this.setState({
        uploadPreviewModal: true,
        contentId: itemAux.list.id,
        contentName: itemAux.list.name,
        item_id: itemAux.list.id
      });
    } else if (itemAux.type !== 17) {
      this.setState({
        iframe: true,
        contentId: itemAux.list.id,
        contentName: itemAux.list.name,
        item_id: itemAux.list.id
      });
    } else {
      if (itemAux.link?.endsWith(".pdf")) {
        this.setState({
          iframe: true,
          contentId: null,
          contentName: itemAux.list.name,
          item_id: itemAux.list.id,
          url: itemAux.link
        });
        return;
      }

      const downloadPath = itemAux.link
        ? itemAux.link.substring(itemAux.link.indexOf("uploads/") + 8)
        : `${itemAux.list.id === 1 ? "activity" : "repo"}/${itemAux.list.name}`;

      axios
        .get(`${URL.api}download/${downloadPath}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, itemAux.list.name);
        });
    }
  };

  updateContentList = () => {
    this.setState(prevState => {
      let contentList = [...prevState.contentList];

      let typeMap = {};
      prevState.types.forEach(item => {
        typeMap[item.id] = {
          title: item.name,
          type_icon: item.icon,
          type_color: item.color
        };
      });

      contentList.forEach(lo => {
        const typeInfo = typeMap[lo.type];
        if (typeInfo) {
          lo.list.subtitle = typeInfo.title;
          lo.list.title = lo.list.name;
          lo.list.type_icon = typeInfo.type_icon;
          lo.list.type_id = lo.type;
          lo.list.type_color = typeInfo.type_color;
        }
      });
      return { contentList };
    });
  };

  userHasSegmentGroup(segmentName) {
    let liveFound = false;
    if (segmentName === "Ao Vivo") {
      for (let i = 0; i < this.props.user.user_modules.length; i++) {
        if (this.props.user.user_modules[i].name === segmentName) {
          liveFound = true;
        }
      }
    }

    return liveFound;
  }

  uploadFile = async () => {
    const { id } = this.props.match.params;
    const formData = new FormData();
    formData.append("file0", this.state.selectedActivityFile);

    try {
      const uploadResponse = await axios.post(
        `${URL.api}file/activity/${this.props.user.user.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      );

      const fileUploaded = uploadResponse.data.files[0];
      let file = fileUploaded;
      file.link = URL.public + fileUploaded.url;

      if (this.state.edit) {
        const obj = {
          activity_id: this.props.trailModal
            ? this.props?.id
            : this.props?.match?.params?.id,
          name: fileUploaded.name,
          link: URL.public + fileUploaded.url
        };

        await axios.post(`${URL.api}activity/activity/insertFile`, obj, {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        });
      }
      this.setState({
        file,
        fileUploaded,
        uploadFileModal: false
      });

      toastr.success("Sucesso", "Arquivo enviado com sucesso.");
    } catch (error) {
      toastr.error("Erro", "Erro ao enviar arquivo.");
    }
  };

  deleteUploadedFile = async () => {
    const { id } = this.props.match.params;

    try {
      await axios.post(
        `${URL.api}removeFile/activity/${this.props.user.user.id}`,
        { name: this.state.file.name },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      );

      await axios.post(
        `${URL.api}activity/activity/deleteFile`,
        { activity_id: id },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      );

      this.setState({ file: null });

      toastr.success("Sucesso", "Arquivo removido com sucesso.");
    } catch (error) {
      toastr.error("Erro", "Erro ao remover o arquivo.");
    }
  };

  render() {
    const isNameFilled = this.state.name.trim() !== "";
    const isDisciplineFilled =
      this.state.disciplinesSelected &&
      this.state.disciplinesSelected.length > 0;

    const late =
      !this.state.loading &&
      new Date(this.state.activity?.activity_end) < new Date();

    const isMobile = window.innerWidth <= 768; // Ajuste este breakpoint se o seu carrossel ativar em outra largura
    // Cada fluxo esconde os seus: a trilha por regra de percurso, a atividade
    // comum por decisão de produto. O corte é de vitrine — `state.types` fica
    // inteiro, então objeto já salvo continua renderizando certo.
    const availableTypes = this.state.types.filter(type =>
      this.isTrailActivity
        ? !isTipoOcultoNaTrilha(type.name)
        : !isTipoOcultoNaAtividade(type.name)
    );
    let displayTypes = availableTypes;

    if (isMobile && !this.state.showAllTypes) {
      const mainTypeNames = ["Arquivo", "Aula", "Exercício", "Link", "Upload"];
      const mainTypes = availableTypes.filter(type =>
        mainTypeNames.includes(type.name)
      );

      displayTypes = [
        ...mainTypes,
        {
          id: "ver_todos",
          name: "Ver Todos",
          icon: "fa fa-plus",
          color: "primary",
          activity: true
        }
      ];
    }

    return (
      <>
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        <ModalActivity
          modalState={this.state.formularioPreview.show}
          toggleModal={this.fecharPreviaFormulario}
          title={`Visualizar formulário${
            this.state.contentName ? ` - ${this.state.contentName}` : ""
          }`}
          backdrop="static"
          size="xl"
          className="educandus modalActivity formulario-builder-modal"
          noFooter
          onClose={this.fecharPreviaFormulario}
        >
          {this.state.formularioPreview.loading && (
            <Loading top="45" left="50" />
          )}
          {this.state.formularioPreview.formulario && (
            <FormularioEditor
              key={this.state.formularioPreview.formulario.id}
              formulario={this.state.formularioPreview.formulario}
              token={this.props.user.token}
              readOnly
              showReadOnlyNotice={false}
              onCancel={this.fecharPreviaFormulario}
            />
          )}
        </ModalActivity>
        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            title={this.state.contentName}
            onClose={() =>
              this.setState({ iframe: false, showViewModal: true })
            }
            aula={this.state.contentId}
            atividade={this.state.activity_id}
            act_item_id={this.state.item_id}
            act_execution_id={late ? undefined : this.state.execution_id}
            currentRoute={this.props.currentRoute}
            url={!this.state.contentId && this.state.url}
          />
        )}
        <ModalTools
          show={this.state.modalTool}
          tool={this.state.toolId}
          title={this.state.toolName}
          onClose={() =>
            this.setState({ modalTool: false, showViewModal: true })
          }
          activity={this.state.activity_id}
          students={this.state.studentsList}
          currentRoute={this.props.currentRoute}
        />
        {this.state.textProductionViewer.id !== "" ? (
          <LiterarteModal
            id={this.state.textProductionViewer.id}
            user_id={this.props.user.user.id}
            show={this.state.textProductionViewer.show}
            onClose={() =>
              this.setState(prevState => ({
                textProductionViewer: {
                  ...prevState.textProductionViewer,
                  show: false,
                  showViewModal: true
                }
              }))
            }
            title={this.state.contentName}
            value={this.state.textProductionViewer.value}
            onChange={value =>
              this.setState(prevState => ({
                textProductionViewer: {
                  ...prevState.textProductionViewer,
                  value
                }
              }))
            }
            disableLiterarteModal={this.disableLiterarteModal}
            hideSaveButton
          />
        ) : null}
        <CModal
          show={this.state.listQuestion.show}
          onClose={() =>
            this.setState({
              listQuestion: {
                show: false
              },
              showViewModal: true
            })
          }
          size="lg w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>{this.state.contentName}</CModalTitle>
          </CModalHeader>
          {this.state.listQuestion.show && (
            <ApplicatedQuestionList
              viewModal
              activityId={this.state.activity_id}
              currentRoute={this.props.currentRoute}
              allocation_id={this.state.allocation_id}
              id={this.state.listQuestion.id}
              history={this.props.history}
              prototype={false}
              item_id={this.state.item_id}
              execution_id={this.state.execution_id}
              result_type={this.state.activity.result_type}
              ended={late}
              close={() =>
                this.setState(
                  prevState => ({
                    listQuestion: {
                      id: prevState.listQuestion.id,
                      show: false
                    },
                    showViewModal: true
                  }),
                  () => this.handleActivity()
                )
              }
              end_date={this.state.activity.activity_end}
            />
          )}
        </CModal>

        <CModal
          show={this.state.evaluationStatisticsModal}
          onClose={() => this.setState({ evaluationStatisticsModal: false })}
          size="lg"
        >
          <CModalHeader closeButton>
            <CModalTitle>Estatísticas de Avaliação</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p>
              Este é o modal para exibir as estatísticas de avaliação. (Conteúdo
              em desenvolvimento)
            </p>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() =>
                this.setState({ evaluationStatisticsModal: false })
              }
            >
              Fechar
            </CButton>
          </CModalFooter>
        </CModal>

        {!this.state.loading ? (
          <CCard>
            <Modal
              isOpen={this.state.showViewModal}
              toggle={null}
              className={null}
              onOpened={() => {
                if (!this.state.edit) {
                  this.componentDidMount();
                }
              }}
              size={this.isTrailActivity ? "xl" : "lg"}
            >
              <ModalHeader className="d-flex justify-content-end">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.setState({ showViewModal: false });
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
              <ModalBody>
                {/* Na trilha, o que o aluno recebe é o TABULEIRO — a trilha
                    lúdica substitui a lista de itens na tela dele (é o que
                    `components/ItensDaAtividade` faz). Mostrar `Cards` +
                    `Widgets` aqui seria pré-visualizar justamente aquilo que a
                    trilha veio substituir. */}
                {this.isTrailActivity ? (
                  <PreviaDoAluno
                    itens={this.state.contentList}
                    regiaoId={this.state.trailRegion}
                    nomeDaTrilha={this.state.name}
                  />
                ) : (
                  <>
                    <Cards
                      header={
                        this.state.name
                          ? `${this.state.name}`
                          : this.labels.nomePlaceholder
                      }
                      body={{
                        type: 0,
                        text: this.state.ValorDescricao
                          ? JSON.stringify(this.state.ValorDescricao)
                          : "Descrição"
                      }}
                    />
                    {this.state.contentList.length !== 0 && (
                      <Widgets
                        itens={this.state.contentList}
                        openItem={this.openItem}
                        closeItem={this.closeItem}
                        teacher
                        onEvaluationStatistics={id =>
                          this.setState({ evaluationStatisticsModal: true })
                        }
                        isViewModeCreateActivity
                      />
                    )}
                  </>
                )}
              </ModalBody>
            </Modal>
            <CCardHeader className="d-flex align-items-center">
              {!this.props.trailModal && (
                <div className="w-100 d-flex align-items-center">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column"
                    }}
                  >
                    <h4 className="card-title mb-1">
                      {`${this.state.edit ? "Editar" : "Criar"} ${
                        this.labels.entidade
                      }`}
                    </h4>
                    <div className="small text-muted">
                      {this.state.edit
                        ? this.labels.editarSubtitulo
                        : this.labels.criarSubtitulo}
                    </div>
                  </div>
                </div>
              )}
            </CCardHeader>
            <CCardBody className="row p-3">
              <div className="flex-column col-12 col-lg-6 d-flex">
                {this.state.fase === 1 ? (
                  <>
                    <FormGroup className="mb3">
                      <CLabel className="text-muted">
                        {this.labels.nomeLabel}
                      </CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          value={this.state.name}
                          onChange={this.changeName}
                          placeholder={this.labels.nomePlaceholder}
                        />
                      </InputGroup>
                    </FormGroup>
                    {this.isTrailActivity && (
                      <FormGroup className="mb3">
                        <CLabel className="text-muted">Região da trilha</CLabel>
                        {/* Cartões com o mascote, e não um <select> de texto: a
                            região define o cenário, o mascote e as 22 cartas que
                            o aluno vai colecionar, e nada disso cabia no rótulo
                            "Norte — Amazônia".

                            Na EDIÇÃO fica travada e sem nenhuma marcada, e é
                            deliberado: `singleView` não devolve a região, e
                            marcar a padrão diria ao professor que a trilha dele
                            é do Nordeste sem que ninguém saiba disso. */}
                        <EscolhaDeRegiao
                          valor={this.state.trailRegion}
                          onEscolher={this.changeRegiaoDaTrilha}
                          travada={this.state.edit}
                          aviso={
                            this.state.edit
                              ? TRILHA_REGIAO_TRAVADA_AVISO
                              : "Define o cenário, o mascote e as cartas que o aluno vai colecionar."
                          }
                        />
                      </FormGroup>
                    )}

                    <FormGroup className="mb3">
                      <CLabel className="text-muted">
                        Componente curricular
                      </CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Select
                          isMulti
                          placeholder="Selecione"
                          name="Selecione"
                          options={this.state.disciplinesList}
                          value={this.state.disciplinesSelected}
                          className="basic-multi-select flex-1"
                          classNamePrefix="select"
                          onChange={this.changeDiscipline}
                          /* A trilha escolhe o componente curricular como
                             qualquer atividade: o campo só espera o nome, que é
                             o que libera o resto do formulário. Até 05/10/2026
                             ele vinha travado em Matemática — ver
                             `config/minhasTrilhas`. */
                          isDisabled={!isNameFilled}
                        />
                      </InputGroup>
                    </FormGroup>
                    <div className="d-flex justify-content-between">
                      {!this.props.trailModal && (
                        <div className="w-100 d-flex align-items-center flex-column flex-sm-row flex-md-column flex-xl-row">
                          <FormGroup className="w-100 mr-sm-2 mr-md-0 mr-xl-2">
                            <CLabel className="text-muted">Série</CLabel>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-text-width" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Select
                                isClearable
                                placeholder="Selecione"
                                name="Selecione"
                                isDisabled={!this.state.disciplineIds?.length}
                                options={this.state.seriesSelectList}
                                value={this.state.serie_selected}
                                className="basic-multi-select flex-1"
                                classNamePrefix="select"
                                onChange={this.changeSerie}
                              />
                            </InputGroup>
                          </FormGroup>
                          <FormGroup className="w-100 ml-sm-2 ml-md-0 ml-xl-2">
                            <CLabel className="text-muted">Habilidade</CLabel>
                            <InputGroup className="d-flex flex-nowrap">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-text-width" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Select
                                isMulti
                                placeholder="Selecione"
                                name="Selecione"
                                isDisabled={
                                  !this.state.disciplineIds?.length ||
                                  !this.state.abilitiesSelectList?.length
                                }
                                options={this.state.abilitiesSelectList}
                                value={this.state.abilitiesSelected}
                                className="basic-multi-select flex-1 w-100"
                                classNamePrefix="select"
                                onChange={this.changeAbilities}
                              />
                            </InputGroup>
                          </FormGroup>
                        </div>
                      )}
                    </div>
                    {/* Disponibilidade e Execução não aparecem na TRILHA, e só
                        nela: uma trilha é sempre privada e sempre sequencial —
                        é o sequencial que faz um nó bloquear o seguinte. Os
                        quatro botões ficavam só desabilitados, o que sugeria
                        que um dia poderiam mudar. Os VALORES continuam indo no
                        payload (ver saveActivity). Atividade e avaliação seguem
                        com os dois campos, intactos. */}
                    {!this.isTrailActivity && (
                      <div className="d-flex mb-2 justify-content-between w-100 flex-column flex-sm-row">
                        <FormGroup className="mr-sm-2 w-100">
                          <CLabel className="text-muted">Disponiblidade</CLabel>
                          <CInputGroup className="d-flex align-items-center flex-nowrap">
                            <CButton
                              color="primary"
                              className="d-flex w-100 justify-content-center align-items-center pl-3 pr-3 pt-2 pb-2 rounded-left rounded-right-0"
                              onClick={() => this.changePrivate(true)}
                              variant={`${
                                this.state.isPrivate === false ? "outline" : ""
                              }`}
                            >
                              <span>Privada</span>
                            </CButton>
                            <CButton
                              color="primary"
                              className="d-flex w-100 justify-content-center align-items-center pl-3 pr-3 pt-2 pb-2 rounded-right rounded-left-0"
                              variant={`${
                                this.state.isPrivate === true ? "outline" : ""
                              }`}
                              onClick={() => this.changePrivate(false)}
                            >
                              <span>Pública</span>
                            </CButton>
                          </CInputGroup>
                        </FormGroup>
                        <FormGroup className="ml-sm-2 w-100">
                          <CLabel className="text-muted">Execução</CLabel>
                          <CInputGroup className="d-flex align-items-center flex-nowrap w-100">
                            <CButton
                              color="primary"
                              className="d-flex w-100 justify-content-center align-items-center pl-3 pr-3 pt-2 pb-2 rounded-left rounded-right-0"
                              onClick={() =>
                                this.setState({ sequential_execution: false })
                              }
                              variant={`${
                                this.state.sequential_execution === true
                                  ? "outline"
                                  : ""
                              }`}
                            >
                              <span>Livre</span>
                            </CButton>
                            <CButton
                              color="primary"
                              className="d-flex w-100 justify-content-center align-items-center pl-3 pr-3 pt-2 pb-2 rounded-right rounded-left-0"
                              variant={`${
                                this.state.sequential_execution === false
                                  ? "outline"
                                  : ""
                              }`}
                              onClick={() =>
                                this.setState({ sequential_execution: true })
                              }
                            >
                              <span>Sequencial</span>
                            </CButton>
                          </CInputGroup>
                        </FormGroup>
                      </div>
                    )}
                    <span className="spacer"></span>
                    <FormGroup className="mb3">
                      {/* Na trilha a descrição é secundária — o que o aluno vê
                          é o tabuleiro —, então ela ocupa 96px em vez dos 300px
                          que o `.editor-wrapper` global impõe, e diz que é
                          opcional (é, e ninguém tinha dito). Quem precisar de
                          espaço expande. Atividade e avaliação não mudam. */}
                      {this.isTrailActivity ? (
                        <div className="ct-rotulo-linha">
                          <CLabel className="text-muted mb-0">
                            Descrição (opcional)
                          </CLabel>
                          <button
                            type="button"
                            className="ct-botao-expandir"
                            onClick={() =>
                              this.setState(estado => ({
                                descricaoExpandida: !estado.descricaoExpandida
                              }))
                            }
                            title={
                              this.state.descricaoExpandida
                                ? "Recolher a descrição"
                                : "Expandir a descrição"
                            }
                          >
                            <i
                              className={`fa fa-${
                                this.state.descricaoExpandida
                                  ? "compress"
                                  : "expand"
                              }`}
                            />
                          </button>
                        </div>
                      ) : (
                        <CLabel className="text-muted">Descrição</CLabel>
                      )}
                      <InputGroup
                        className={
                          this.isTrailActivity
                            ? `ct-descricao${
                                this.state.descricaoExpandida
                                  ? " ct-descricao--expandida"
                                  : ""
                              }`
                            : undefined
                        }
                      >
                        <RichText
                          setValorDescricao={val =>
                            this.setState({ ValorDescricao: val })
                          }
                          description={this.state.description}
                          editavel
                          toolbar
                        />
                      </InputGroup>
                    </FormGroup>
                  </>
                ) : (
                  ""
                )}
              </div>

              <div className="flex-column col-12 col-lg-6 d-flex">
                {isNameFilled ? (
                  isDisciplineFilled ? (
                    this.state.types.length > 0 ? (
                      <div className="mt-3 mb-2">
                        <text>{this.labels.objetosInstrucao}</text>
                        {/* Na TRILHA a área de soltar do ClickAndDrop sai
                            (`dropArea={false}`) e quem desenha os passos é o
                            PercursoDaTrilha. A lista de cima — o acervo, que é
                            só clique — continua a mesma nos dois fluxos.

                            O motivo é medido: a faixa do ClickAndDrop é
                            `direction="horizontal"` sem quebra de linha, com
                            `overflowX: scroll` e `.typeBox { width: 100px }`,
                            então mostra 4 de 9 itens por vez e corta o nome em
                            82px úteis.

                            A atividade comum segue com ela, intacta. O
                            ClickAndDropActivity só é usado por esta tela, mas
                            esta tela serve três fluxos (atividade, avaliação e
                            o EditNodeModal), e nenhum deles pediu grade. */}
                        <ClickAndDropActivity
                          list={displayTypes}
                          list2={this.state.contentList}
                          dropDisable={false}
                          dropArea={!this.isTrailActivity}
                          dropName={this.labels.dropName}
                          getOrder={this.getOrder}
                          getSelected={this.getSelected}
                          selectedItem={this.selectedItem}
                          editItem={this.editItem}
                          removeItem={this.removeItem}
                          direction="horizontal"
                          dontChangeListOnSelect
                          isEditMode={this.state.edit}
                          showOrder={this.isTrailActivity}
                        />
                        {this.isTrailActivity && (
                          <>
                            <div className="mt-3 mb-2">
                              {this.labels.dropName}
                            </div>
                            <PercursoDaTrilha
                              itens={this.state.contentList}
                              // `state.types` e não `displayTypes`: no celular a
                              // lista de cima é reduzida a cinco tipos mais o
                              // "Ver Todos", e um passo cujo tipo ficou de fora
                              // apareceria sem ícone nem cor.
                              tipos={this.state.types}
                              onReordenar={this.getOrder}
                              onEditar={this.editItem}
                              onRemover={this.removeItem}
                            />
                          </>
                        )}
                      </div>
                    ) : (
                      <Loading top="45" left="50" />
                    )
                  ) : (
                    <div className="alert alert-info" role="alert">
                      Agora, selecione um <b>Componente Curricular</b> para{" "}
                      {this.labels.semComponente}
                    </div>
                  )
                ) : (
                  <div className="alert alert-info" role="alert">
                    Por favor, preencha o campo "
                    <b>{this.labels.nomePlaceholder}</b>" para continuar.
                  </div>
                )}
              </div>
              {this.state.uploadModal && (
                <UploadCreator
                  show
                  onClose={() =>
                    this.setState({ uploadModal: false, editing: false })
                  }
                  getContent={content => this.getContent(content, false)}
                />
              )}
              {this.state.uploadPreviewModal && (
                <UploadModal
                  readOnly
                  upload_id={this.state.contentId}
                  onClose={() =>
                    this.setState({
                      uploadPreviewModal: false,
                      showViewModal: true
                    })
                  }
                />
              )}
              {this.state.linkModal && (
                <LinkCreator
                  show={this.state.linkModal}
                  onClose={() =>
                    this.setState({
                      linkModal: false,
                      editing: false,
                      currentLOLink: null
                    })
                  }
                  getContent={content => this.getContent(content, false)}
                  isEditMode={this.state.edit}
                  currentLOLink={this.state.currentLOLink}
                />
              )}
              {this.state.textModal && (
                <TextCreator
                  show={this.state.textModal}
                  onClose={() =>
                    this.setState({
                      textModal: false,
                      editing: false,
                      currentLOLink: null,
                      viewMode: false
                    })
                  }
                  getContent={content => this.getContent(content, false)}
                  showOnly={this.state.viewMode}
                  currentLOLink={this.state.currentLOLink}
                />
              )}
              {this.state.fileModal && (
                <FileCreator
                  show
                  onClose={() =>
                    this.setState({ fileModal: false, editing: false })
                  }
                  doneArchive={(content, name) =>
                    this.doneArchive(content, name)
                  }
                />
              )}
              <ModalActivity
                toggleModal={this.toggleModal}
                modalState={this.state.modal}
                title={this.state.modalProps.title}
                className="educandus modalActivity"
                backdrop="static"
                size="xl"
                noFooter
                onClose={() =>
                  this.setState({ editing: false, newList: false })
                }
              >
                {this.state.modalProps.type < 12 ? (
                  <ContentComponentActivity
                    type={this.state.modalProps.type}
                    discipline={this.state.disciplineIds?.[0]}
                    disciplinesSelected={this.state.disciplinesSelected}
                    typeName={this.state.modalProps.typeName}
                    activity
                    typeColor={
                      this.state.types.find(
                        type => type.id === this.state.modalProps.type
                      )?.color
                    }
                    typeIcon={
                      this.state.types.find(
                        type => type.id === this.state.modalProps.type
                      )?.icon
                    }
                    getContent={content => this.getContent(content)}
                    currentRoute={this.props.currentRoute}
                  />
                ) : (
                  ""
                )}
                {this.state.modalProps.type === 12 ? (
                  this.state.newList ? (
                    <QuestionListCreate
                      newList={this.selectedListItem}
                      history={this.props.history}
                      editListId={this.state.editListId}
                      cloneListId={this.state.cloneListId}
                      afterClone={id =>
                        this.setState({
                          editListId: id,
                          cloneListId: undefined
                        })
                      }
                      name={this.state.name}
                      closeModal={this.closeModal}
                    />
                  ) : (
                    <QuestionListImportModal
                      selectedListChanger={this.selectedListItem}
                      newList={() =>
                        this.setState(prevState => ({
                          newList: !prevState.newList,
                          cloneListId: null,
                          editListId: null
                        }))
                      }
                      history={this.props.history}
                      editList={id =>
                        this.setState({
                          editListId: id,
                          cloneListId: null,
                          newList: true
                        })
                      }
                      cloneList={id =>
                        this.setState({
                          cloneListId: id,
                          editListId: null,
                          newList: true
                        })
                      }
                    />
                  )
                ) : (
                  ""
                )}
                {this.isFormularioType(this.state.modalProps.type) ? (
                  <FormularioPicker
                    token={this.props.user.token}
                    selectedId={
                      (this.state.editing && this.state.editIndex !== -1
                        ? this.state.contentList[this.state.editIndex]
                        : null
                      )?.list?.id
                    }
                    onSelect={this.selectedFormularioItem}
                    onClose={() =>
                      this.setState({
                        modal: false,
                        editing: false,
                        editIndex: -1
                      })
                    }
                  />
                ) : null}
                {this.state.modalProps.type === 14 ? (
                  <>
                    <FormGroup className="mb3">
                      <CLabel>Título</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          value={this.state.textProduction.name}
                          onChange={this.changeTextProductionName}
                          placeholder="Título do texto"
                        />
                      </InputGroup>
                    </FormGroup>

                    <FormGroup className="mb3">
                      <CLabel>Pontuação máxima</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="number"
                          value={this.state.textProduction.note}
                          onChange={e => this.changeTextProductionNote(e)}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <CLabel>Tipo</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="select"
                          value={this.state.textProduction.type}
                          onChange={e =>
                            this.setState(prevState => ({
                              textProduction: {
                                ...prevState.textProduction,
                                type: e.target.value
                              }
                            }))
                          }
                        >
                          <option value="">Escolha o tipo</option>
                          {this.state.textTypes.map(type => (
                            <React.Fragment key={type.id}>
                              <option value={type.id}>{type.name}</option>
                            </React.Fragment>
                          ))}
                        </Input>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <CLabel>Critérios</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="select"
                          defaultValue=""
                          onChange={this.changeTextProductionCriterion}
                        >
                          <option value="">Escolha um critério</option>
                          <optgroup label="Critérios do sistema">
                            {this.state.criterions.map(criterion => (
                              <React.Fragment key={criterion.id}>
                                {criterion.visible &&
                                criterion.user_id === null ? (
                                  <React.Fragment key={criterion.id}>
                                    <option value={criterion.id}>
                                      {criterion.name}
                                    </option>
                                  </React.Fragment>
                                ) : null}
                              </React.Fragment>
                            ))}
                          </optgroup>
                          <optgroup label="Critérios do usuário">
                            {this.state.criterions.map(criterion => (
                              <React.Fragment key={criterion.id}>
                                {criterion.visible &&
                                criterion.user_id ===
                                  this.props.user.user.id ? (
                                  <React.Fragment key={criterion.id}>
                                    <option value={criterion.id}>
                                      {criterion.name}
                                    </option>
                                  </React.Fragment>
                                ) : null}
                              </React.Fragment>
                            ))}
                          </optgroup>
                        </Input>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <CLabel>Adicione um critério que não existe</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          value={this.state.newTextProductionCriterion}
                          onChange={this.changeNewTextProductionCriterion}
                          placeholder="Digite o novo critério aqui"
                        />
                        <CButton
                          color="primary"
                          onClick={() => this.createTextProductionCriterion()}
                        >
                          Adicionar
                        </CButton>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <h3>Critérios escolhidos</h3>
                      {this.state.textProduction.criterion.map(
                        (criterion, index) => (
                          <div
                            key={criterion.id}
                            style={{ flexDirection: "row" }}
                          >
                            <div style={{ flexDirection: "row" }}>
                              {`- ${criterion.name} `}
                              <i
                                className="fa fa-remove"
                                style={{ color: "#F00", cursor: "pointer" }}
                                onClick={() =>
                                  this.removeTextProductionCriterion(
                                    criterion.id
                                  )
                                }
                              ></i>
                            </div>
                            <div>
                              <FormGroup className="mb3">
                                <InputGroup>
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <i className="fa fa-text-width" />
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    type="number"
                                    value={criterion.note}
                                    onChange={e =>
                                      this.changeTextProductionCriterionNote(
                                        e,
                                        index
                                      )
                                    }
                                  />
                                </InputGroup>
                              </FormGroup>
                            </div>
                          </div>
                        )
                      )}
                    </FormGroup>
                    <CButton
                      color="primary"
                      onClick={() => this.createTextProduction()}
                    >
                      Criar
                    </CButton>
                  </>
                ) : (
                  ""
                )}
                {this.state.modalProps.type === 17 ? (
                  <Uploader
                    type="activity"
                    maxFiles={1}
                    allowMultiple
                    labelIdle="Clique aqui ou arraste um arquivo para cá"
                    done={uploads => this.doneArchive(uploads)}
                  />
                ) : (
                  ""
                )}
              </ModalActivity>
              <Modal isOpen={this.state.uploadFileModal} size="md">
                <form
                  onSubmit={e => {
                    e.preventDefault();
                    this.uploadFile();
                  }}
                >
                  <ModalHeader
                    toggle={() => this.setState({ uploadFileModal: false })}
                  >
                    Upload de arquivo para atividade
                  </ModalHeader>
                  <ModalBody>
                    {this.state.file ? (
                      <button
                        className="d-flex border rounded p-0 w-100"
                        type="button"
                        onClick={() =>
                          window.open(this.state.file.link, "_blank")
                        }
                      >
                        <div className="bg-warning p-3 h-100 rounded-left">
                          <i className="fa fa-file"></i>
                        </div>
                        <div className="d-flex align-items-center justify-content-start my-3 mx-2">
                          {this.state.file.name}
                        </div>
                      </button>
                    ) : (
                      <div className="form-group">
                        <label>Selecione o arquivo</label>
                        <br />
                        <input
                          type="file"
                          className="text-truncate"
                          onChange={e =>
                            this.setState({
                              selectedActivityFile: e.target.files[0]
                            })
                          }
                        />
                      </div>
                    )}
                  </ModalBody>
                  {this.state.file ? (
                    <ModalFooter>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => this.deleteUploadedFile()}
                      >
                        <i className="fa fa-trash mr-1"></i>
                        Remover arquivo
                      </button>
                    </ModalFooter>
                  ) : (
                    <ModalFooter>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() =>
                          this.setState({ uploadFileModal: false })
                        }
                      >
                        Cancelar
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Enviar
                      </button>
                    </ModalFooter>
                  )}
                </form>
              </Modal>
            </CCardBody>
            <CCardFooter className="d-flex align-items-center">
              <div className="d-flex align-items-center justify-content-end w-100">
                {!this.isTrailActivity && (
                  <CButton
                    color="primary"
                    className="d-flex justify-content-center align-items-center mr-2"
                    onClick={() => this.setState({ uploadFileModal: true })}
                    disabled={this.state.creating}
                  >
                    <span>
                      <i className="fa fa-file mr-2"></i>Anexar arquivo
                    </span>
                  </CButton>
                )}

                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center mr-2"
                  onClick={() =>
                    this.setState({ showViewModal: true }, () => {
                      this.updateContentList();
                    })
                  }
                  disabled={this.state.creating}
                >
                  <>
                    <span>
                      <i className="fa fa-eye mr-2"></i>
                      {/* Na trilha o botão diz o que ele mostra: o tabuleiro
                          como o aluno vai receber. "Visualizar" servia para a
                          pré-visualização da lista de itens. */}
                      {this.isTrailActivity ? "Visão do aluno" : "Visualizar"}
                    </span>
                  </>
                </CButton>

                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => this.saveActivity()}
                  disabled={this.state.creating}
                >
                  <>
                    <span style={this.state.creating ? { opacity: 0 } : null}>
                      <i className="fa fa-cloud-upload mr-2"></i>Salvar
                    </span>
                    {this.state.creating && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </>
                </CButton>
              </div>
            </CCardFooter>
          </CCard>
        ) : (
          <Loading top="45" left="50" />
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCreate);
